import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseService } from '../base.service';
var CountryService = /** @class */ (function (_super) {
    tslib_1.__extends(CountryService, _super);
    function CountryService(http) {
        var _this = _super.call(this, 'country', http) || this;
        _this.http = http;
        return _this;
    }
    CountryService.prototype.ngOnInit = function () {
    };
    return CountryService;
}(BaseService));
export { CountryService };
